module.exports = __webpack_public_path__ + "static/img/mypetrol-kpdn.8210582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mypetrol-kpdn.png
// module id = dUCc
// module chunks = 107